import { render, staticRenderFns } from "./BoAffiliate.vue?vue&type=template&id=11dd5331&"
import script from "./BoAffiliate.vue?vue&type=script&lang=js&"
export * from "./BoAffiliate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports